// ModuleSidebar.jsx
import React, { useState, useEffect, useRef } from "react";
import "./ModuleSidebar.css";
import { RiArrowUpSLine, RiArrowDownSLine } from "react-icons/ri";
import { TbFileInvoice, TbFolder, TbFolderOpen, TbPlus, TbArrowsHorizontal } from "react-icons/tb";
import { useLanguage } from "../../LanguageProvider";
import AlertBox from "../AlertBox/AlertBox";
import RenameModal from "./components/RenameModal/RenameModal";
import { useToaster } from "../../ToasterProvider";
import UserSearchInput from "../../pages/ProjectsWindow/components/ProjectAuthorization/components/UserSearchInput";
import { AiOutlineFileAdd, AiOutlineFolderAdd } from "react-icons/ai";
import ReactDOM from "react-dom";

// NestedAccordion bileşeni (global collapse/expand destekli)
function NestedAccordion({
  item,
  selectedSubmenu,
  onSubmenuClick,
  onGroupContextMenu,
  filteredSubmenu,
  selectedFolderId,
  onFolderClick,
  globalToggleType,
  globalToggleKey,
}) {
  const [open, setOpen] = useState(false);

  const toggleOpen = (e) => {
    e.stopPropagation();
    setOpen((prev) => !prev);

    if (onFolderClick) {
      if (selectedFolderId === item.id) {
        onFolderClick("");
      } else {
        onFolderClick(item.id);
      }
    }
  };

  const handleRightClick = (e) => {
    e.preventDefault();
    if (onGroupContextMenu) {
      onGroupContextMenu(e, item);
    }
  };

  // nestedSubmenu'yu filtrelenmiş veriden al, yoksa normalini kullan
  const submenuItems = filteredSubmenu || item.nestedSubmenu;

  // Global collapse / expand sinyalini dinle
  useEffect(() => {
    if (globalToggleType === "collapse") {
      setOpen(false);
    } else if (globalToggleType === "expand") {
      setOpen(true);
    }
  }, [globalToggleKey, globalToggleType]);

  return (
    <div className="nested-accordion">
      <div
        className={`submenu-item-container nested-header ${selectedSubmenu === item.id ? "selected" : ""
          }`}
        onClick={toggleOpen}
      >
        <div
          className={`submenu-item ${selectedFolderId === item.id ? "selected-folder" : ""
            }`}
          onContextMenu={handleRightClick}
        >
          {open ? (
            <TbFolderOpen
              size={16}
              style={{ marginRight: "8px", position: "relative", top: "3px" }}
            />
          ) : (
            <TbFolder
              size={16}
              style={{ marginRight: "8px", position: "relative", top: "3px" }}
            />
          )}
          {item.title}
        </div>
      </div>
      {open &&
        submenuItems &&
        submenuItems.map((nestedItem, index) => (
          <div
            key={index}
            className={`submenu-item-container nested-item ${selectedSubmenu === nestedItem.id ? "selected" : ""
              }`}
            onClick={() => onSubmenuClick(nestedItem)}
          >
            <div
              className="submenu-item"
              style={{
                flexDirection: "row",
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
              }}
            >
              {(nestedItem.isTemporary || nestedItem.unsaved) && (
                <div className="unsaved-mark" />
              )}
              <TbFileInvoice
                size={16}
                style={{
                  marginRight: "8px",
                  position: "relative",
                  top: "3px",
                  marginLeft: "10px",
                  minWidth: "16px",
                  minHeight: "16px",
                }}
              />
              <span className="submenu-item-text">{nestedItem.title}</span>
            </div>
          </div>
        ))}
    </div>
  );
}

export default function ModuleSidebar({
  menus,
  title,
  onSubmenuClick,
  addEntitiy,
  addSecondaryEntity,
  selectedSubmenu,
  type = "",
  contextMenuRenameOnClick,
  contextMenuDeleteOnClick,
  deleteMessage,
  showSearch = false,
  groupContextMenuRenameOnClick,
  groupContextMenuDeleteOnClick,
  groupDeleteMessage,
  bigAddButtononClick,
  bigAddButtonLabel,
  hideBranch,
  selectedFolderId,
  onFolderClick,
  checkPermission,
  onRightClick,
  renameModalTitle = "",
}) {
  const initializeOpenSections = () => {
    const initialState = {};
    menus.forEach((menu, menuIndex) => {
      menu.sections.forEach((_, sectionIndex) => {
        const key = `${menuIndex}-${sectionIndex}`;
        initialState[key] = true; // Başlangıçta hepsi açık
      });
    });
    return initialState;
  };

  const groupContextMenuRef = useRef(null);

  const { getTranslation } = useLanguage();
  const { toastWarning } = useToaster();

  const [openSections, setOpenSections] = useState(initializeOpenSections);
  const [contextMenu, setContextMenu] = useState(null);
  const [isAlertOpen, setIsAlertOpen] = useState(false);
  const [isRenameModalOpen, setIsRenameModalOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const [groupContextMenu, setGroupContextMenu] = useState(null);
  const [isGroupAlertOpen, setIsGroupAlertOpen] = useState(false);
  const [isGroupRenameModalOpen, setIsGroupRenameModalOpen] = useState(false);

  const [modalTitle, setModalTitle] = useState(renameModalTitle);
  const [objID, setObjID] = useState("");

  // Global collapse/expand sinyali için
  const [globalToggleType, setGlobalToggleType] = useState(null); // "collapse" | "expand" | null
  const [globalToggleKey, setGlobalToggleKey] = useState(0); // Aynı işlem art arda da tetiklensin diye

  // --- Resize state'leri ---
  const [sidebarWidth, setSidebarWidth] = useState(230);
  const [isResizing, setIsResizing] = useState(false);
  const sidebarRef = useRef(null);

  useEffect(() => {
    setModalTitle(renameModalTitle);
  }, [renameModalTitle]);

  useEffect(() => {
    setOpenSections((prev) => {
      const updatedOpenSections = {};
      menus.forEach((menu, menuIndex) => {
        menu.sections.forEach((_, sectionIndex) => {
          const key = `${menuIndex}-${sectionIndex}`;
          updatedOpenSections[key] = key in prev ? prev[key] : true;
        });
      });
      return updatedOpenSections;
    });
  }, [menus]);

  useEffect(() => {
    const handleClickOutside = () => {
      if (isAlertOpen || isRenameModalOpen) return;
      setContextMenu(null);
      setGroupContextMenu(null);
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [isAlertOpen, isRenameModalOpen]);

  const toggleSection = (menuIndex, sectionIndex) => {
    const key = `${menuIndex}-${sectionIndex}`;
    setOpenSections((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const handleAddEntityClick = (id) => {
    if (addEntitiy) {
      addEntitiy(id);
    }
  };

  const handleSubmenuClick = (submenuItem) => {
    if (onSubmenuClick) {
      onSubmenuClick(submenuItem);
    }
  };

  const handleGroupContextMenu = (e, groupItem) => {
    e.preventDefault();
    const menuWidth = 150;
    const menuHeight = 50;
    const screenWidth = window.innerWidth;
    const screenHeight = window.innerHeight;
    const x = Math.min(e.clientX, screenWidth - menuWidth);
    const y = Math.min(e.clientY, screenHeight - menuHeight);
    const newData = { x, y, group: groupItem };
    setGroupContextMenu(newData);
    groupContextMenuRef.current = newData;
  };

  const handleContextMenu = (e, section) => {
    if (!contextMenuDeleteOnClick || section.disableContextMenu) return;
    onRightClick(section.id);
    setObjID(section.id);
    e.preventDefault();
    const menuWidth = 150;
    const menuHeight = 50;
    const screenWidth = window.innerWidth;
    const screenHeight = window.innerHeight;
    const x = Math.min(e.clientX, screenWidth - menuWidth);
    const y = Math.min(e.clientY, screenHeight - menuHeight);
    setContextMenu({ x, y, section });
  };

  const handleContextMenuClick = (action) => {
    if (!contextMenu || !checkPermission) {
      toastWarning(getTranslation("noPermission"));
      return;
    }
    if (action === "rename") {
      setIsRenameModalOpen(true);
    } else {
      setIsAlertOpen(true);
    }
  };

  const handleConfirmDelete = () => {
    if (contextMenuDeleteOnClick) {
      contextMenuDeleteOnClick(objID);
    }
    setIsAlertOpen(false);
  };

  const handleConfirmRename = (newTitle) => {
    if (contextMenuRenameOnClick) {
      contextMenuRenameOnClick(objID, newTitle);
    }
    setIsRenameModalOpen(false);
  };

  // --- Collapse All & Expand All handler'ları ---
  const handleCollapseAll = () => {
    // Tüm section'ları kapat
    setOpenSections(() => {
      const closed = {};
      menus.forEach((menu, menuIndex) => {
        menu.sections.forEach((_, sectionIndex) => {
          const key = `${menuIndex}-${sectionIndex}`;
          closed[key] = false;
        });
      });
      return closed;
    });

    // NestedAccordion'lara sinyal gönder
    setGlobalToggleType("collapse");
    setGlobalToggleKey((prev) => prev + 1);
  };

  const handleExpandAll = () => {
    // Tüm section'ları aç
    setOpenSections(() => {
      const opened = {};
      menus.forEach((menu, menuIndex) => {
        menu.sections.forEach((_, sectionIndex) => {
          const key = `${menuIndex}-${sectionIndex}`;
          opened[key] = true;
        });
      });
      return opened;
    });

    // NestedAccordion'lara sinyal gönder
    setGlobalToggleType("expand");
    setGlobalToggleKey((prev) => prev + 1);
  };

  // --- Sağdan tutup genişletip daraltma handler'ı ---
  // --- Sağdan tutup genişletip daraltma handler'ı ---
  const handleResizeMouseDown = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsResizing(true);

    const startX = e.clientX;
    // 👇 ÖNEMLİ: DOM ölçümü yerine state'teki width'i kullan
    const startWidth = sidebarWidth;

    const onMouseMove = (moveEvent) => {
      const delta = moveEvent.clientX - startX;
      const newWidth = Math.min(Math.max(startWidth + delta, 180), 420); // min:180, max:420
      setSidebarWidth(newWidth);
    };

    const onMouseUp = () => {
      setIsResizing(false);
      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("mouseup", onMouseUp);
    };

    document.addEventListener("mousemove", onMouseMove);
    document.addEventListener("mouseup", onMouseUp);
  };

  return (
    <div style={{ height: '100%', display: 'flex', flexDirection: 'row' }}>
      <div
        className={`sidebar-container ${isResizing ? "sidebar-resizing" : ""}`}
        ref={sidebarRef}
        style={{ width: `${sidebarWidth}px` }}
      >
        {/* Üst kısım: Başlık + Collapse/Expand butonları */}
        {title && (
          <div className="sidebar-top">
            <div className="project-title">{title}</div>
            <div className="sidebar-toggle-buttons">
              <button
                className="sidebar-toggle-button"
                onClick={handleCollapseAll}
              >
                {getTranslation("collapseAll") || "Collapse All"}
              </button>
              <button
                className="sidebar-toggle-button"
                onClick={handleExpandAll}
              >
                {getTranslation("expandAll") || "Expand All"}
              </button>
            </div>
          </div>
        )}

        {bigAddButtononClick && (
          <div className="big-add-button">
            <TbPlus size={16} /> {bigAddButtonLabel}
          </div>
        )}

        {/* Arama çubuğu yalnızca showSearch true ise */}
        {showSearch && (
          <div className="sidebar-search">
            <UserSearchInput
              style={{ width: "100%" }}
              placeholder={getTranslation("search")}
              onSearch={setSearchQuery}
              value={searchQuery}
            />
          </div>
        )}

        {menus?.map((menu, menuIndex) => (
          <div key={menuIndex} className="menu-container">
            <ul className="menu">
              {menu.sections.map((section, sectionIndex) => {
                const key = `${menuIndex}-${sectionIndex}`;
                return (
                  <li key={key} className="menu-section">
                    <div
                      className="menu-header"
                      onClick={() => toggleSection(menuIndex, sectionIndex)}
                      onContextMenu={(e) => handleContextMenu(e, section)}
                    >
                      <div className="menu-header-inner">
                        {section.icon}
                        {section.title.length > 13
                          ? section.title.substring(0, 13) + "..."
                          : section.title}
                        {addEntitiy &&
                          !addSecondaryEntity &&
                          section.showEntityButton !== false && (
                            <TbPlus
                              style={{ cursor: "var(--pointer)" }}
                              onClick={(e) => {
                                e.stopPropagation();
                                handleAddEntityClick(section.id);
                              }}
                            />
                          )}
                        {addSecondaryEntity &&
                          section.showEntityButton !== false && (
                            <>
                              <AiOutlineFileAdd
                                style={{ cursor: "var(--pointer)" }}
                                size={15}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleAddEntityClick(section.id);
                                }}
                              />
                              <AiOutlineFolderAdd
                                style={{ cursor: "var(--pointer)" }}
                                size={18}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  addSecondaryEntity(section.id);
                                }}
                              />
                            </>
                          )}
                      </div>
                      <div>
                        {openSections[key] ? (
                          <RiArrowUpSLine size={22} />
                        ) : (
                          <RiArrowDownSLine size={22} />
                        )}
                      </div>
                    </div>
                    {openSections[key] && section.submenu && (
                      <div className="submenu">
                        {section.submenu.map((item, subIndex) => {
                          const query = searchQuery.toLowerCase();

                          // Eğer nested submenu varsa
                          if (item.nestedSubmenu !== undefined) {
                            const filteredNested = item.nestedSubmenu.filter((n) =>
                              n.title.toLowerCase().includes(query)
                            );

                            const titleMatch = item?.title
                              ?.toLowerCase()
                              .includes(query);

                            // Eğer üst başlık veya alt başlıklardan biri eşleşiyorsa göster
                            if (titleMatch || filteredNested.length > 0) {
                              return (
                                <NestedAccordion
                                  key={subIndex}
                                  item={item}
                                  selectedSubmenu={selectedSubmenu}
                                  onSubmenuClick={handleSubmenuClick}
                                  onGroupContextMenu={handleGroupContextMenu}
                                  filteredSubmenu={
                                    !titleMatch ? filteredNested : undefined
                                  }
                                  selectedFolderId={selectedFolderId}
                                  onFolderClick={onFolderClick}
                                  globalToggleType={globalToggleType}
                                  globalToggleKey={globalToggleKey}
                                />
                              );
                            }

                            return null; // hiçbir eşleşme yoksa gösterme
                          }

                          // Normal item (nested değil)
                          if (item.title.toLowerCase().includes(query)) {
                            const hasAnyNestedSubmenu = section.submenu.some(
                              (item) =>
                                item.nestedSubmenu !== undefined &&
                                item.nestedSubmenu.length > 0
                            );

                            return (
                              <div
                                key={subIndex}
                                className={`submenu-item-container ${selectedSubmenu === item.id ? "selected" : ""
                                  }`}
                                style={{
                                  marginBottom: item.icon ? "0px" : "15px",
                                }}
                                onClick={() => handleSubmenuClick(item)}
                              >
                                {!item.icon && !hideBranch && (
                                  <div className="submenu-branch"></div>
                                )}
                                {type === "api" &&
                                  (item.isTemporary || item.unsaved) && (
                                    <div className="unsaved-mark" />
                                  )}
                                <div
                                  className="submenu-item"
                                  style={{
                                    marginBottom: item.icon ? "0px" : "-18px",
                                    alignItems: item.icon ? "center" : "",
                                    display: item.icon ? "flex" : "",
                                    gap: item.icon ? "12px" : "",
                                  }}
                                >
                                  {hasAnyNestedSubmenu && (
                                    <TbFileInvoice
                                      size={16}
                                      style={{
                                        marginRight: "8px",
                                        position: "relative",
                                        top: "3px",
                                      }}
                                    />
                                  )}

                                  <span className="submenu-item-text">  {item.icon && item.icon} {item.title}</span>
                                </div>
                              </div>
                            );
                          }

                          return null;
                        })}
                      </div>
                    )}
                  </li>
                );
              })}
            </ul>
          </div>
        ))}

        {contextMenu &&
          ReactDOM.createPortal(
            <div
              className="module-sidebar-context-menu"
              style={{
                top: `${contextMenu.y}px`,
                left: `${contextMenu.x}px`,
              }}
            >
              <div
                className="module-sidebar-context-menu-item"
                onClick={() => {
                  handleContextMenuClick("rename");
                  setContextMenu(null);
                }}
              >
                {getTranslation("rename")}
              </div>
              <div
                className="module-sidebar-context-menu-item"
                onClick={() => {
                  handleContextMenuClick("delete");
                  setContextMenu(null);
                }}
              >
                {getTranslation("delete")}
              </div>
            </div>,
            document.body
          )}

        {groupContextMenu &&
          ReactDOM.createPortal(
            <div
              className="module-sidebar-context-menu"
              style={{
                top: `${groupContextMenu.y}px`,
                left: `${groupContextMenu.x}px`,
              }}
            >
              <div
                className="module-sidebar-context-menu-item"
                onClick={() => {
                  setIsGroupRenameModalOpen(true);
                  setGroupContextMenu(null);
                }}
              >
                {getTranslation("rename")}
              </div>
              <div
                className="module-sidebar-context-menu-item"
                onClick={() => {
                  setIsGroupAlertOpen(true);
                  setGroupContextMenu(null);
                }}
              >
                {getTranslation("delete")}
              </div>
            </div>,
            document.body
          )}

        {/* Silme onayı */}
        <AlertBox
          isOpen={isAlertOpen}
          title={getTranslation("areYouSure")}
          message={deleteMessage}
          onConfirm={handleConfirmDelete}
          onCancel={() => setIsAlertOpen(false)}
          confirmText={getTranslation("yes")}
          cancelText={getTranslation("no")}
          type={"warning"}
        />

        {/* Yeniden adlandırma modalı */}
        <RenameModal
          isOpen={isRenameModalOpen}
          onClose={() => setIsRenameModalOpen(false)}
          onConfirm={handleConfirmRename}
          title={modalTitle}
          setTitle={setModalTitle}
        />

        <AlertBox
          isOpen={isGroupAlertOpen}
          title={getTranslation("areYouSure")}
          message={groupDeleteMessage}
          onConfirm={() => {
            if (groupContextMenuDeleteOnClick) {
              groupContextMenuDeleteOnClick(
                groupContextMenuRef.current?.group?.id
              );
            }
            setIsGroupAlertOpen(false);
          }}
          onCancel={() => setIsGroupAlertOpen(false)}
          confirmText={getTranslation("yes")}
          cancelText={getTranslation("no")}
          type={"warning"}
        />

        <RenameModal
          isOpen={isGroupRenameModalOpen}
          onClose={() => setIsGroupRenameModalOpen(false)}
          title={modalTitle}
          setTitle={setModalTitle}
          onConfirm={(newTitle) => {
            if (groupContextMenuRenameOnClick) {
              groupContextMenuRenameOnClick(
                groupContextMenuRef.current?.group?.id,
                newTitle
              );
            }
            setIsGroupRenameModalOpen(false);
          }}
        />

        {/* Sağdan tutup genişletme/daraltma alanı */}

      </div>
      <span
        type="button"
        className="sidebar-resizer"
        onMouseDown={handleResizeMouseDown}
        aria-label="Resize sidebar"
      >
        ||
      </span>
    </div>
  );
}